// extracted by mini-css-extract-plugin
export default {"ticker":"Ticker_ticker__xlzeD","text":"Ticker_text__K8d+O"};